var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative"},[_c('iframe-host',{ref:"iframe",attrs:{"src":"/store/UI/CartAnchor.html","width":"50px","height":"40px"}}),_vm._v(" "),_c('a',{staticClass:"position-absolute fill",attrs:{"href":"/store/CartSummary"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749acdec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Cart/Anchor.vue
// module id = 1019
// module chunks = 24